import { MataKuliahResponse } from './types'

export type TMatkulType = MataKuliahResponse['type']

export const MATKUL_TYPE_FILTER_OPTIONS: {
  label: string
  value: TMatkulType
}[] = [
  { label: 'Inti', value: 'INTI' },
  { label: 'Elektif', value: 'ELEKTIF' },
  { label: 'Selektif', value: 'SELEKTIF' },
  { label: 'Pendukung', value: 'PENDUKUNG' },
]
